import React from 'react';
import { Badge } from '../../types';
import BadgeIcon from '../ui/BadgeIcon';

interface BadgeAwardModalProps {
  badge: Badge;
  onClose: () => void;
}

const BadgeAwardModal: React.FC<BadgeAwardModalProps> = ({ badge, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
        <div className="w-24 h-24 mx-auto mb-4">
          <BadgeIcon iconName={badge.icon_name} />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Badge Unlocked!</h2>
        <h3 className="text-xl font-semibold text-blue-600 mb-2">{badge.badge_name}</h3>
        <p className="text-gray-600 mb-6">{badge.description}</p>
        <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700">
          Awesome!
        </button>
      </div>
    </div>
  );
};

export default BadgeAwardModal;